import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import { userReducer } from '@stencil/user-reducer';

export function createReduxStore({ reducers = {}, initialState = undefined }) {
  const middlewares = [thunk];
  let composeEnhancers = compose;

  if (__CLIENT__ && __DEV__) {
    middlewares.push(logger);
  }

  if (__CLIENT__) {
    composeEnhancers = __PROD__ ? compose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  }

  return createStore(
    combineReducers({ ...userReducer, ...reducers }),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );
}

export default createReduxStore;
